export const ValidationConstants = {
  cryptotoken: {
    namePattern: '^[a-zA-Z0-9_-]+$',
  },
  state: {
    maxLength: 64,
  },
  locality: {
    maxLength: 128,
  },
  commonName: {
    maxLength: 128,
  },
  orgName: {
    maxLength: 64,
  },
  orgUnit: {
    maxLength: 64,
  },
  profile: {
    namePattern: '^[a-zA-Z0-9_-]+$',
    pathLengthConstraint: {
      max: 2147483647, // int32
    },
  },
  urlRegExp:
    /^(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})$/,
  minCaValidityDays: 5475,
  maxCaValidityDays: 18250,
};
